import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const deleteBusinessTag = createAsyncThunk(
  'tags/deleteBusinessTag',
  async ({ tagId, business_id, group_id }, { getState, dispatch, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      
      const response = await axios.delete(
        `${ROOT_URL}/chat-tag/${tagId}?business_id=${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );


      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const deleteBusinessTagSlice = createSlice({
  name: 'deleteBusinessTag',
  initialState,
  reducers: {
    resetDeleteTagState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBusinessTag.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteBusinessTag.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(deleteBusinessTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetDeleteTagState } = deleteBusinessTagSlice.actions;
export default deleteBusinessTagSlice.reducer; 